(function() {
	'use strict';

	angular
		.module('app.createCustomReport')
		.factory('createCustomReportService', ['$q', '$http', '$rootScope', 
			function ($q, $http, $rootScope){
				var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes) || result);
                        }
                    })
                        .error(function (result) {
                            deferred.reject(result);
                        });

                    return deferred.promise;
                }

                function getSections(loader) {
                    var url_getSections = $rootScope.apiUrl + 'measure/getSections'
                    return handleRequest(url_getSections, 'GET', null, loader);
                }

                function createCustomReport(params, loader) {
                    var url_createCustomReport = $rootScope.apiUrl + 'measure/createCustomReport'
                    return handleRequest(url_createCustomReport, 'POST', params, loader);
                }

                service.getSections = getSections;
                service.createCustomReport = createCustomReport;

                return service;
		}])
})();